export type BiomeId =
  | 'ocean' | 'beach' | 'desert' | 'grass' | 'forest'
  | 'tundra' | 'mountain' | 'snow';

export type BiomeInput = {
  height: number;              // 0..1
  moisture?: number;           // 0..1, default 0.5
  temperature?: number;        // 0..1, default 0.5 (0 cold, 1 hot)
  waterLevel: number;          // 0..1
};

export function classifyBiome(i: BiomeInput): BiomeId {
  const m = i.moisture ?? 0.5;
  const t = i.temperature ?? 0.5;
  if (i.height < i.waterLevel) return 'ocean';
  if (i.height < i.waterLevel + 0.02) return 'beach';
  if (i.height > 0.95) return 'snow';
  if (i.height > 0.80) return 'mountain';
  // Mid elevation — climate drives biome.
  if (t < 0.3) return 'tundra';
  if (t > 0.7 && m < 0.3) return 'desert';
  if (m > 0.6) return 'forest';
  return 'grass';
}
